"use strict";
/**
 * Font Awesome conditional loading
 * Only loads the icon variants that are actually used on the page
 *
 * @package StandOut
 * @since 2.0.0
 */
document.addEventListener("DOMContentLoaded", () => {
    const fontawesome = document.querySelectorAll("[class*='fa-']");
    const hasButtons = document.querySelector(".button__icon") !== null;
    const hasNavDropdowns = document.querySelector(".menu-item-has-children") !== null;
    if (fontawesome.length > 0 || hasButtons || hasNavDropdowns) {
        const variants = [
            import("@fortawesome/fontawesome-pro/css/fontawesome.min.css"),
            import("../../css/libraries/fontawesome/fontawesome.css"),
        ];
        const hasSharp = document.querySelector("[class*='fa-sharp']") !== null;
        const hasSolid = document.querySelector("[class*='fa-solid']") !== null;
        const hasRegular = document.querySelector("[class*='fa-regular']") !== null || hasNavDropdowns;
        const hasLight = document.querySelector("[class*='fa-light']") !== null || hasButtons;
        const hasThin = document.querySelector("[class*='fa-thin']") !== null;
        const hasDuotone = document.querySelector("[class*='fa-duotone']") !== null;
        if (hasSolid) {
            variants.push(import("@fortawesome/fontawesome-pro/css/solid.min.css"));
        }
        if (hasRegular) {
            variants.push(import("@fortawesome/fontawesome-pro/css/regular.min.css"));
        }
        if (hasLight) {
            variants.push(import("@fortawesome/fontawesome-pro/css/light.min.css"));
        }
        if (hasThin) {
            variants.push(import("@fortawesome/fontawesome-pro/css/thin.min.css"));
        }
        if (hasDuotone) {
            variants.push(import("@fortawesome/fontawesome-pro/css/duotone.min.css"));
        }
        if (hasSharp && hasSolid) {
            variants.push(import("@fortawesome/fontawesome-pro/css/sharp-solid.min.css"));
        }
        if (hasSharp && hasRegular) {
            variants.push(import("@fortawesome/fontawesome-pro/css/sharp-regular.min.css"));
        }
        if (hasSharp && hasLight) {
            variants.push(import("@fortawesome/fontawesome-pro/css/sharp-light.min.css"));
        }
        if (hasSharp && hasThin) {
            variants.push(import("@fortawesome/fontawesome-pro/css/sharp-thin.min.css"));
        }
        if (hasSharp && hasDuotone) {
            variants.push(import("@fortawesome/fontawesome-pro/css/sharp-duotone-solid.min.css"));
        }
        Promise.all(variants).catch((error) => {
            console.error("Failed to load Font Awesome:", error);
        });
    }
});
